import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-logoDefault",
  "use": "icon-icon-logoDefault-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-icon-logoDefault\"><path d=\"M488.79 0C770.9 0 999.618 229.23 999.618 512s-228.693 512-510.83 512h-46.445V651.63H512c76.946 0 139.313-62.513 139.313-139.63a139.483 139.483 0 0 0-134.095-139.532L512 372.37H372.687V1024H24.381V0h464.408z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol